import { ApplicationRef, ComponentRef, createComponent, inject, Injectable, EnvironmentInjector } from '@angular/core';
import { ToastComponent } from './toast.component';
import { TranslateService } from '@ngx-translate/core';
import type { ToastType } from './toast.component';
export type { ToastType } from './toast.component';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly appRef = inject(ApplicationRef);
  private readonly injector = inject(EnvironmentInjector);
  private readonly translate = inject(TranslateService);

  show(messageKey: string, type: ToastType = 'success', duration = 3500) {
    const message = this.translate.instant(messageKey);
    this.showMessage(message, type, duration);
  }

  showMessage(message: string, type: ToastType = 'success', duration = 3500) {
    if (!message.trim()) {
      return;
    }

    const ref: ComponentRef<ToastComponent> = createComponent(ToastComponent, {
      environmentInjector: this.injector,
    });

    ref.instance.message = message;
    ref.instance.type = type;
    ref.instance.translate = this.translate;

    this.appRef.attachView(ref.hostView);
    document.body.appendChild(ref.location.nativeElement);

    ref.instance.close = () => {
      this.appRef.detachView(ref.hostView);
      ref.destroy();
    };

    setTimeout(() => {
      ref.instance.dismissing = true;
      ref.changeDetectorRef.detectChanges();
      setTimeout(() => {
        this.appRef.detachView(ref.hostView);
        ref.destroy();
      }, 350);
    }, duration);
  }

  success(messageKey: string) {
    this.show(messageKey, 'success');
  }

  error(messageKey: string) {
    this.show(messageKey, 'error');
  }

  errorMessage(message: string, duration = 3500) {
    this.showMessage(message, 'error', duration);
  }
}
